var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { SkeletonRow } from "syf-component-library/ui/atoms/Loader/Skeleton/subcomponents";
import { Body } from "syf-component-library/ui/typography";
import { useTranslation } from "react-i18next";
import { useProfile } from "../../../const/syfApiQueries";
export var EmailSkeleton = styled(SkeletonRow)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0px;\n  margin-top: 4px;\n"], ["\n  margin: 0px;\n  margin-top: 4px;\n"])));
export var BoldedText = styled(Body)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-weight: bold;\n"], ["\n  font-weight: bold;\n"])));
var UserEmail = function (_a) {
    var accountId = _a.accountId;
    var t = useTranslation().t;
    var _b = useProfile(accountId), userProfileInfo = _b.data, isLoadingUserProfileInfo = _b.isLoading, isErrorUserProfileInfo = _b.isError;
    if (isLoadingUserProfileInfo) {
        return _jsx(EmailSkeleton, __assign({ width: "200px" }, { children: "\u200C" }));
    }
    if (isErrorUserProfileInfo) {
        return _jsx(BoldedText, { children: t("labels.unavailable") });
    }
    return _jsx(BoldedText, { children: userProfileInfo === null || userProfileInfo === void 0 ? void 0 : userProfileInfo.profile["cipher.email"] });
};
export default UserEmail;
var templateObject_1, templateObject_2;
